import "./cooperative.scss";
import "../../../js/core";
import "../../../components/site-elements/other-blocks/tags/expand-tags/expand-tags";
import "./critical/cooperative-ajax";

(function () {
  var stickyBannerTop = document.querySelector("#sticky-banner-top");

  if (stickyBannerTop) {
    //to check when element get's position sticky
    var observer = new IntersectionObserver(
      function (entries) {
        // no intersection
        if (entries[0].intersectionRatio === 0)
          document.querySelector("#sticky-banner").classList.add("sticky");
        // fully intersects
        else if (entries[0].intersectionRatio === 1)
          document.querySelector("#sticky-banner").classList.remove("sticky");
      },
      {
        threshold: [0, 1],
      }
    );
    observer.observe(stickyBannerTop);
  }
})();
